// Translated toolbar/agenda labels for react-big-calendar (shared by the shift and appointment calendars)
export const calendarMessages = (t, extra = {}) => ({
  today: t("Today"),
  previous: t("Back"),
  next: t("Next"),
  month: t("Month"),
  week: t("Week"),
  day: t("Day"),
  agenda: t("Agenda"),
  date: t("Date"),
  time: t("Time"),
  showMore: total => `+${total} ${t("more")}`,
  ...extra
});
